import React, { Suspense } from 'react';
import { CenteredLoadingSpinner, useFeature } from '@ole-ui/ole-ui-components';
import { observer } from 'mobx-react';
import { withErrorBoundary } from 'react-error-boundary';
import ComponentError from 'components/Error/ComponentError';
import { handleError } from 'services/ErrorService';
import useMobxStores from 'hooks/useMobxStores';
import { EnablementFeatureFlags } from 'config/featureFlags';
import SearchV1 from './SearchV1';

import './styles.scss';

const SearchV2 = React.lazy(
  () => import(/* webpackChunkName: 'search-v2' */ './SearchV2'),
);

const SearchLoading = () => (
  <div className="search__loading">
    <CenteredLoadingSpinner />
  </div>
);

const Search = () => {
  const { featuresStore } = useMobxStores();
  const isNewSearchEnabled = useFeature({
    section: 'enablements',
    flagName: EnablementFeatureFlags.NewSearch,
    defaultFlagValue: false,
  });

  if (!featuresStore.allFeaturesFetched) {
    return <SearchLoading />;
  }

  if (!isNewSearchEnabled) {
    return <SearchV1 />;
  }

  return (
    <Suspense fallback={<SearchLoading />}>
      <SearchV2 />
    </Suspense>
  );
};

export default withErrorBoundary(observer(Search), ComponentError, handleError);
